import React, { useEffect, useState } from "react";
import "./SettlementReport.css";
import { useSelector } from "react-redux";
import {
  getSettlementByUTR,
  getSettlementReport,
} from "../../../config/LiveApi";
import { toast } from "react-toastify";
import ExcelDownloader from "./ExcelDownload";
import Pagination from "./Pagination";
import { FaSearch } from "react-icons/fa";
import { IoReload } from "react-icons/io5";
import DateFilter from "../../../components/common/DateFilter";

const SettlementTable = () => {
  const token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState({ data: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchUTR, setSearchUTR] = useState("");
  const [searchResult, setSearchResult] = useState(null);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const getSettlementData = async (start = startDate, end = endDate) => {
    setLoading(true);
    try {
      const response = await getSettlementReport(
        token,
        currentPage,
        start,
        end,
      );

      setTableData(response.data);
      setTotalPages(response.data.totalPages);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) getSettlementData();
  }, [currentPage, token]);

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    getSettlementData(start, end);
  };

  const reloadfunction = () => {
    window.location.reload();
  };

  const handleUTRSearch = async () => {
    if (!searchUTR) {
      toast.warning("Please enter a UTR ID");
      return;
    }

    setLoading(true);
    try {
      const response = await getSettlementByUTR(token, searchUTR);

      if (response?.data) {
        setSearchResult(response.data);
      } else {
        setSearchResult(null);
        toast.error("No settlement found for this UTR");
      }
    } catch (err) {
      toast.error("Error fetching settlement by UTR");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settlement-report-container">
      {/* HEADER */}
      <div className="settlement-report-excel">
        <div className="settlement-report-title">Settlement Report</div>

        <ExcelDownloader
          data={tableData.data}
          fileName="Settlement_Report"
          role={role}
        />
      </div>
         {/* DATE FILTER (NEW) */}
      <DateFilter onDateChange={handleDateChange} />
      
      {/* SEARCH + DATE FILTER */}
      <div className="settlement-report-excel">
        <div className="serch-section-utr">
          <div className="search-report">
            <input
              type="number"
              className="search-input-report"
              placeholder="Enter UTR Id"
              value={searchUTR}
              onChange={(e) => setSearchUTR(e.target.value)}
            />

            <FaSearch className="search-icon" />

            <button className="go-btn-report" onClick={handleUTRSearch}>
              Go
            </button>

            <button className="reload-btn-report" onClick={reloadfunction}>
              <IoReload />
            </button>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="settlement-report-table-wrapper">
        <table className="settlement-report-table">
          <thead>
            <tr>
              {role !== "admin" && <th>Provider Name</th>}
              <th>Settlement Amount</th>
              <th>Status</th>
              <th>Settlement Delay</th>
              <th>OrderId</th>
              <th>UTR</th>
              <th>Tnx Date</th>
              <th>Created At</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8">Loading...</td>
              </tr>
            ) : searchResult ? (
              <tr>
                {role !== "admin" && (
                  <td>{searchResult.providerName || "-"}</td>
                )}
                <td>{searchResult.settlementAmount}</td>
                <td>{searchResult.status ? "True" : "False"}</td>
                <td>{searchResult.settlementDelay ? "Yes" : "No"}</td>
                <td>{searchResult.orderId}</td>
                <td>{searchResult.utr}</td>
                <td>{new Date(searchResult.txnDate).toLocaleString()}</td>
                <td>{new Date(searchResult.createdAt).toLocaleString()}</td>
              </tr>
            ) : tableData.data?.length > 0 ? (
              tableData.data.map((reportData, i) => (
                <tr key={i}>
                  {role !== "admin" && <td>{reportData?.providerName}</td>}
                  <td>{reportData?.settlementAmount}</td>
                  <td>{reportData?.status === 1 ? "True" : "False"}</td>
                  <td>{reportData?.settlementDelay === 1 ? "Yes" : "No"}</td>
                  <td>{reportData?.orderId}</td>
                  <td>{reportData?.utr}</td>
                  <td>{new Date(reportData.txnDate).toLocaleString()}</td>
                  <td>{new Date(reportData.createdAt).toLocaleString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </div>
  );
};

export default SettlementTable;
